import * as tslib_1 from "tslib";
import * as firebase from "firebase/app";
import { BehaviorSubject } from "rxjs";
import { User } from "../interfaces/user";
import { switchMap, take, first } from "rxjs/operators";
import { of } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "@angular/fire/auth";
import * as i2 from "@angular/fire/firestore";
export class AuthService {
    constructor(afAuth, db) {
        this.afAuth = afAuth;
        this.db = db;
        this.user = new BehaviorSubject(null);
        this.afAuth.authState
            .pipe(switchMap(auth => {
            if (auth) {
                return this.db
                    .collection("users")
                    .doc(auth.uid)
                    .valueChanges();
            }
            else {
                return of(null);
            }
        }))
            .subscribe(user => {
            this.user.next(user);
        });
    }
    getUserIDAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const user = yield this.afAuth.authState.pipe(first()).toPromise();
            console.log(user);
            return user.uid;
        });
    }
    getUserUid() {
        return this.user.value.uid;
    }
    getUser() {
        return this.user.asObservable();
    }
    googleLogin() {
        const provider = new firebase.auth.GoogleAuthProvider();
        return this.afAuth.auth.signInWithPopup(provider).then(credential => {
            this.user.next(new User(credential.user));
        });
    }
    doEmailRegister(register) {
        return new Promise((resolve, reject) => {
            firebase
                .auth()
                .createUserWithEmailAndPassword(register.email, register.password)
                .then(credential => {
                this.afAuth.auth.currentUser
                    .updateProfile({
                    displayName: register.displayName,
                    photoURL: register.photoURL
                })
                    .then(user => {
                    this.updateUser(this.afAuth.auth.currentUser);
                });
                resolve(credential);
            }, err => reject(err));
        });
    }
    updatePhotoURL(photoURL) {
        return new Promise((resolve, reject) => {
            this.afAuth.auth.currentUser
                .updateProfile({
                photoURL: photoURL
            }).then(user => {
                this.updateUser(this.afAuth.auth.currentUser);
                resolve(user);
            });
        });
    }
    doEmailLogin(login) {
        return new Promise((resolve, reject) => {
            firebase
                .auth()
                .signInWithEmailAndPassword(login.username, login.password)
                .then(credential => {
                this.updateUser(credential.user);
                resolve(credential);
            }, err => reject(err));
        });
    }
    doLogOut() {
        this.afAuth.auth.signOut();
        this.user.next(null);
    }
    updateUser(authData) {
        const userData = new User(authData);
        const testObject = Object.assign({}, userData);
        delete testObject.roles;
        this.db.collection('users').doc(authData.uid)
            .snapshotChanges()
            .pipe(take(1))
            .subscribe(user => {
            if (user.payload.exists) {
                this.db.collection('users').doc(authData.uid).update(testObject);
            }
            else {
                this.db.collection('users').doc(authData.uid).set(testObject);
            }
        });
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.AngularFireAuth), i0.ɵɵinject(i2.AngularFirestore)); }, token: AuthService, providedIn: "root" });
